import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  plansContainer: {
    marginTop: theme.spacing(2)
  },
  planOption: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.spacing(2.5),
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    border: `2px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.background.paper,
    height: '100%',
    minHeight: '420px',
    borderRadius: theme.spacing(1),
    position: 'relative',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 16px rgba(0,0,0,0.12)'
    }
  },
  // Standard plan default styling (when NOT selected)
  standardPlanOption: {
    border: `3px solid ${theme.palette.primary.main}`,
    background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, rgba(25, 118, 210, 0.02) 100%)`,
    transform: 'scale(1.02)',
    boxShadow: '0 8px 24px rgba(25, 118, 210, 0.15)',
    '&:hover': {
      transform: 'scale(1.02) translateY(-2px)',
      boxShadow: '0 12px 32px rgba(25, 118, 210, 0.2)'
    }
  },
  // Basic plan default styling (when NOT selected)
  basicPlanOption: {
    opacity: 0.85,
    '&:hover': {
      opacity: 1,
      borderColor: theme.palette.grey[400]
    }
  },
  // Selected state for ANY plan
  selectedPlanOption: {
    border: `3px solid ${theme.palette.warning.main} !important`,
    boxShadow: '0 8px 24px rgba(255, 152, 0, 0.3) !important',
    transform: 'translateY(-2px) !important',
    opacity: '1 !important',
    // Override Standard plan styling when selected
    '&$standardPlanOption': {
      transform: 'scale(1.02) translateY(-2px) !important',
      boxShadow: '0 12px 32px rgba(255, 152, 0, 0.3) !important'
    }
  },
  standardPlanContainer: {
    position: 'relative',
    height: '100%'
  },
  planContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  planHeader: {
    fontSize: '1.1rem',
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  standardPlanHeader: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: '1.2rem',
    '& svg': {
      color: theme.palette.warning.main
    }
  },
  basicPlanHeader: {
    color: theme.palette.text.primary,
    fontSize: '1.1rem'
  },
  planDescription: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
    lineHeight: 1.4
  },
  planPrice: {
    fontSize: '1.25rem',
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1)
  },
  featuresList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    flex: 1,
    marginTop: theme.spacing(1)
  },
  featureItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.25),
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    lineHeight: 1.4,
    '& svg': {
      color: theme.palette.primary.main,
      fontSize: '0.5rem',
      marginTop: '0.4em'
    }
  },
  textContent: {
    flex: 1,
    '& strong': {
      fontWeight: 'bold',
      display: 'inline'
    }
  },
  recommendedBadge: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    fontWeight: 600,
    '& .MuiChip-label': {
      fontSize: '0.75rem'
    }
  },
  radio: {
    color: theme.palette.primary.main,
    alignSelf: 'flex-start',
    marginTop: theme.spacing(0.5)
  },
  checked: {
    color: theme.palette.primary.main
  },
  termsSection: {
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.grey[300]}`
  }
}));
export default useStyles;